/**
 * Unified per-item media controls — used by every media uploader/renderer.
 *
 * Two independent axes the admin can set on each photo/video:
 *   SIZE (span) — how much grid space a tile occupies:
 *      square (1×1) · tall (1×2) · wide (2×1) · hero (2×2)
 *   FIT          — how the media fills its frame:
 *      cover   → "Fill screen"      (fills, edges may crop)
 *      contain → "Fit whole image"  (whole media shown, may letterbox)
 *      natural → "Keep original"    (natural pixel size, centered)
 */
export const SIZES = [
  { id: 'square', label: 'Square' },
  { id: 'tall', label: 'Tall' },
  { id: 'wide', label: 'Wide' },
  { id: 'hero', label: 'Hero' },
];

export const FITS = [
  { id: 'cover', label: 'Fill screen' },
  { id: 'natural', label: 'Keep original' },
  { id: 'contain', label: 'Fit whole image' },
];

// Legacy span values → new SIZE ids.
const SPAN_ALIAS = { normal: 'square', large: 'hero' };
export const normSpan = (span) => SPAN_ALIAS[span] || span || 'square';

// Grid placement for a collage/grid tile.
export const spanToGridClass = (span) => {
  switch (normSpan(span)) {
    case 'tall': return 'col-span-1 row-span-2';
    case 'wide': return 'col-span-2 row-span-1';
    case 'hero': return 'col-span-2 row-span-2';
    case 'square':
    default: return 'col-span-1 row-span-1';
  }
};

// Fixed-box dimensions for non-grid contexts (e.g. review thumbnails).
export const spanToBoxClass = (span) => {
  switch (normSpan(span)) {
    case 'tall': return 'w-24 aspect-[3/4]';
    case 'wide': return 'w-44 aspect-[16/9]';
    case 'hero': return 'w-full max-w-md aspect-[16/9]';
    case 'square':
    default: return 'w-28 aspect-square';
  }
};
